module.exports = __webpack_public_path__ + "img/1.14664d17.jpg";